import { Fragment } from 'react'
import Article, {
  ArticleContentBox,
  DisclaimerBox,
  DisclaimerText,
  DisclaimerTitle,
} from '../../shared_components/Library/Article'
import { H3, P, Strong } from '../../shared_components/Library/Typeography'
import { Box } from '../../shared_components/UI/Box'
import Settings04 from '../../shared_components/Icons/Settings04'
import Lock03 from '../../shared_components/Icons/Lock03'
import CurrencyDollar from '../../shared_components/Icons/CurrencyDollar'
import { ThemedAnchor, ThemedLink } from '../../shared_components/ThemedButton'
import routes from '../../router/routes'

function StakingApyArticle() {
  return (
    <Article
      title="ZAP Staking APY"
      bannerUrl="/staking-apy-article-cover.png"
      content={
        <Fragment>
          <ArticleContentBox>
            <H3 fw="semibold">How is my APY calculated?</H3>

            <P c="text-secondary">
              <Strong>Base APY.</Strong>Our Base APY pool emits 12,950 $ZAP
              daily to stakers. Your share of the Base APY pool is calculated
              via the following formula:   <br />(Your # of tokens staked / Total number
              of tokens staked) * 12,950 <br />If you are a Vault staker, all your
              (even unvested) tokens are staked and factored into the above
              calculation.
            </P>

            <P c="text-secondary">
              <Strong>Vault APY.</Strong>Vault stakers also receive a bonus
              multiplier based on the duration of staking. This bonus multiplier
              only applies to currently vested tokens at the point of staking
              your Vault. Bonus tokens emissions are paid out from a separate
              pool.
            </P>

            <P c="text-secondary">
              <Strong>Your APY.</Strong>Your APY is a combination of Base APY
              and Vault APY (only for Vault stakers) and calculated via the
              following formula: <br /><br />((Your # of tokens staked + Your token rewards)
              / Your # of tokens staked) - 1
            </P>

            <P c="text-secondary">
              <Strong>Note:</Strong> APY is variable and depends on how many
              tokens overall are staked and receive rewards.
            </P>
          </ArticleContentBox>
          <ArticleContentBox>
            <H3 fw="semibold">How it Works</H3>

            <P c="text-secondary">
              <Box g={10}>
                <Settings04 color="white" />
                Choose how many tokens/vaults you would like to stake and a
                duration.
              </Box>
            </P>

            <P c="text-secondary">
              <Box g={10}>
                <Lock03 color="white" />
                Claim your APY by locking up your tokens/vault for 3, 6, or 12
                months.
              </Box>
            </P>

            <P c="text-secondary">
              <Box g={10}>
                <CurrencyDollar color="white" />
                Receive liquid $ZAP rewards into your wallet daily.
              </Box>
            </P>
          </ArticleContentBox>

          <DisclaimerBox>
            <DisclaimerTitle>Disclaimer</DisclaimerTitle>
            <DisclaimerText>
              Tokens available on this platform are not supported by ZAP. ZAP is
              not an investment service; tokens can lose significant value at
              any moment. By using ZAP, you accept all associated risks and
              agree to our{' '}
              <a
                href="https://docs.zap.tech/zaponchain/other/terms-and-conditions"
                target="_blank"
                rel="noreferrer"
              >
                Terms and Conditions
              </a>
              .
            </DisclaimerText>
          </DisclaimerBox>
          <Box g={10} ac fw>
            <ThemedLink to={routes.staking.tokens} $styleType="primary">
              Back to staking
            </ThemedLink>
            <ThemedAnchor
              $styleType="tertiary"
              p="11px 20px 11px 16px"
              href="https://discord.gg/zaponchain"
            >
              <img
                src="/supported-socials/discord.svg"
                alt="ZAP Discord"
                height="20px"
                width="20px"
                style={{ borderRadius: '50%' }}
              />
              Discord
            </ThemedAnchor>
            <ThemedAnchor
              $styleType="tertiary"
              p="11px 20px 11px 16px"
              href="https://x.com/zaponchain"
            >
              <img
                src="/supported-socials/twitter.svg"
                alt="ZAP X"
                height="20px"
                width="20px"
                style={{ borderRadius: '50%' }}
              />
              X
            </ThemedAnchor>
          </Box>
        </Fragment>
      }
    />
  )
}

export default StakingApyArticle
